import React, { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'shamrock-clover-ui/dist/clover/components/Button/Button';
import { setDismissCookie } from '../../redux/actions/appActions';
import css from './styles/customerAlertBox.scss';

const CustomerAlertBox: FunctionComponent<CustomerAlertBoxProps> =
  ({ title, description }) => {
    const dispatch = useDispatch();
    return (
      <div className={css.issueContainer}>
        <div className={css.issueTitle}>{title}</div>
        <div>{description}</div>
        <div className={css.dismissButton}>
          <Button
            buttonStyle='text'
            onClick={
              () => {
                dispatch(setDismissCookie());
              }
            }>
            Dismiss
          </Button>
        </div>
      </div>
    );
  };

export default CustomerAlertBox;

interface CustomerAlertBoxProps {
  title: string;
  description: string;
}

